import React, { useState } from "react";

import { Button, Card, CardActions, CardContent, CardHeader, Divider, Modal, TextField, Tooltip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";

import { useModalStyles } from "../destinations/modals/styles";
import { AddIcon } from "../components/icons/themes/windows10";

interface PHIAllowListEditModalProps {
  allowListType: string;
  allowListedProps: string[];
  open: boolean;
  onSave: (allowedProps: string[]) => void;
  onClose: () => void;
}

export const PHIAllowListEditModal: React.FC<PHIAllowListEditModalProps> = ({allowListType, allowListedProps, open, onSave, onClose}) => {
  const classes = useModalStyles();

  const [wipAllowListedProps, updateWipAllowListedProps] = useState(allowListedProps.length != 0 ? allowListedProps : [""]);

  const onDelete = (index: number) => {
    const newAllowListedProps = wipAllowListedProps.slice();
    newAllowListedProps.splice(index, 1);
    updateWipAllowListedProps(newAllowListedProps);
  }

  const onChange = (index: number, newProp: string) => {
    const newAllowListedProps = wipAllowListedProps.slice();
    newAllowListedProps[index] = newProp;
    updateWipAllowListedProps(newAllowListedProps);
  };

  return (
    <Modal
      open={open}
    >
      <Card className={clsx(classes.root, classes.smallModal)}>
        <CardHeader
          title={`Allow List: ${allowListType}`}
          classes={{ action: classes.closeIconAction }}
          action={<CloseIcon onClick={onClose} />}
        />
        <Divider />
        <CardContent>
          <div className="justify-items-stretch" style={{ width: "100%" }}>
            {wipAllowListedProps.map((prop, index) => {
              return (
                <div className="flex items-stretch" key={index}>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    name={"Allowlisted Property"}
                    placeholder={"Allowlisted Property"}
                    onChange={(event: any) =>
                      onChange(index, event.target.value)
                    }
                    value={prop || ""}
                    key={index}
                    variant="outlined"
                    type={"text"}
                    inputProps={{ style: { fontFamily: "monospace" } }}
                    className={clsx(classes.inputField, "mb-2 fs-exclude")}
                  />
                  <span className="flex flex-wrap justify-end">
                    <Tooltip title="Remove allowlisted property">
                      <div
                        className="hover:bg-navy-200 p-1 rounded-full flex justify-center items-center"
                        onClick={() => onDelete(index)}
                      >
                        <CloseIcon />
                      </div>
                    </Tooltip>
                  </span>
                </div>
              );
            })}
            <Button
              color="primary"
              className="text-xs bg-navy-100 text-navy-800 inline-block inline-flex items-center px-3 py-1 rounded cursor-pointer hover:bg-navy-200"
              onClick={() => updateWipAllowListedProps([...wipAllowListedProps, ""])}
            >
              <AddIcon className="mr-1" style={{ width: 16 }} />
              Add Property
            </Button>
          </div>
        </CardContent>
        <Divider />
        <CardActions className={classes.actions}>
          <Button onClick={onClose}>Close</Button>
          <Button color="primary" onClick={() => onSave(wipAllowListedProps)} variant="contained">
            Save
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}
